import {useLexicalComposerContext} from '@lexical/react/LexicalComposerContext'
import selectionAlwaysOnDisplay from "./utils/selectionAlwaysOnDisplay"
import {useEffect} from 'react'

/**
 * Custom SelectionAlwaysOnDisplay plugin adapted for Lexical 0.12.6.
 * Note: Replace with the official Lexical SelectionAlwaysOnDisplay plugin after upgrading Lexical
 * to a version that includes it.
 */

type Props = Readonly<{
    onReposition?: (node: Array<HTMLElement>) => void;
}>

export function SelectionAlwaysOnDisplay({onReposition}: Props): null {
    const [editor] = useLexicalComposerContext()
    useEffect(() => {
        return selectionAlwaysOnDisplay(editor, onReposition)
    }, [editor, onReposition])

    return null
}
